import { Eye } from "@gravity-ui/icons";
import { Button, Icon } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import { Controller, Control } from "react-hook-form";
import { productSelectionStore } from "src/store/atoms";

import { ProductFilters } from "../../ProductFilters";

interface ViewAllSelectedButtonProps {
  control: Control<ProductFilters>;
  buttonText: string;
}

export const ViewAllSelectedButton = ({
  control,
  buttonText,
}: ViewAllSelectedButtonProps) => {
  const [selectedProductSample] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );

  return (
    <Controller
      name="viewAllSelected"
      control={control}
      render={({ field }) => (
        <Button
          view={field.value ? "action" : "outlined"}
          disabled={!selectedProductSample}
          onClick={() => field.onChange(!field.value)}
          title={buttonText}
          style={{ marginTop: "8px" }}
        >
          <Icon data={Eye} />
          {buttonText}
        </Button>
      )}
    />
  );
};
